import styled from "styled-components";
import React, { ReactElement, useEffect, useState } from "react";
import { Grid, GridElement } from "./grid";
import { themes } from "./theme";

const StyledBody = styled.div`
  background-size: cover;
  color: ${themes.primary.main};
  background-color: ${themes.background.sub};
  position: relative;
  display: flex;
  align-items: start;
  justify-content: center;
  height: 100%;
`;

const StyledTextHeader = styled.div<{animate: boolean}>`
  text-align: center;
  font-size: 3.6rem;
  font-weight: 200;
  color: ${themes.primary.main};
  margin-top: -2.6rem;
  padding-bottom: 2.6rem;
`;

const StyledTextFooter = styled.div<{animate: boolean}>`
  text-align: center;
  font-size: 3.6rem;
  font-weight: 200;
  margin-bottom:-2rem;
  padding-top: 2.6rem;
  color: ${themes.primary.main};
`;

const StyledTextLetters = styled.span<{animate: boolean}>`
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.6s;
    opacity: 0;
    &:nth-child(4){
        opacity:1;
    };
    ${(props) =>
        props.animate && `
        opacity:1;
    `}
`;

const StyledTextBody = styled.div`
  text-align: center;
  font-size: 1.6rem;
  font-weight: 200;
  padding: 0 1rem 0 1rem;
  color: ${themes.primary.main};
  word-wrap: break;
`;

const Body = () : ReactElement => {
    const [toggle, setToggle] = useState(false)

    const handleScroll = () => {
        const position = window.scrollY;
        if(position > 95) {
            setToggle(true)
        }
        if(position <= 50){
            setToggle(false)
        }
    }

    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => {
            window.removeEventListener('scroll', handleScroll);
		  };
	}, []);

    return     <StyledBody>
        <Grid parts={1} dimension={"1"}>
            <GridElement position=''>
                <StyledTextHeader animate={toggle} >
                    <StyledTextLetters animate={toggle} >E</StyledTextLetters>
                    <StyledTextLetters animate={toggle} >M</StyledTextLetters>
                    <StyledTextLetters animate={toggle} >P</StyledTextLetters>
                    <StyledTextLetters animate={toggle} >A</StyledTextLetters>
                    <StyledTextLetters animate={toggle} >T</StyledTextLetters>
                    <StyledTextLetters animate={toggle} >H</StyledTextLetters>
                    <StyledTextLetters animate={toggle} >Y</StyledTextLetters>
                </StyledTextHeader>   
            </GridElement>
            <GridElement position=''>
                <StyledTextBody>
                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.                </StyledTextBody>
                <StyledTextFooter animate={toggle}>
                    Band name
                </StyledTextFooter>  
                </GridElement>
        </Grid>
  </StyledBody>
}

export {Body}